// Authored example bodies (country-level recipes), bundled as raw markdown.
// Keyed "guideSlug/exampleSlug" — the example must exist in EXAMPLES_BY_GUIDE
// for the detail route to resolve.
//
// INVARIANT (same as guide-bodies): only add bodies for examples under
// ungated guides — bodies are client-bundled.
//
// PARKED: the two visitor journey heatmap recipes are withheld on purpose.
// Visitor Journey is expensive to serve, so we are not promoting it for now.
// Their markdown is kept in this directory, unreferenced:
//
//   us-vj-heatmap-console-kepler.md
//   us-vj-heatmap-python.md
//
// To bring them back, restore the two imports and map entries here, restore
// their entries under "store-profiling" in EXAMPLES_BY_GUIDE (docs-data/
// guides.ts), and restore the paragraph linking to them in
// guide-bodies/store-profiling.md. Nothing else is needed: the example route,
// the guide cards, and the /llms.txt inventory all key off this map, so
// registering the bodies is what makes the pages exist again.
import usGroceryBrandComparison from "./us-grocery-brand-comparison.md?raw"
import usHowFarVisitorsTravel from "./us-how-far-visitors-travel.md?raw"
import usHebSanAntonioStoreProfile from "./us-heb-san-antonio-store-profile.md?raw"
import usCbgScoring from "./us-cbg-scoring.md?raw"
import usSproutsWhiteSpace from "./us-sprouts-white-space-denver.md?raw"
import usGroceryPenetration from "./us-grocery-penetration-denver.md?raw"
import usCandidateMalls from "./us-candidate-malls-colorado.md?raw"
import us16thStreet from "./us-16th-street-denver.md?raw"
import noGrunerlokka from "./no-grunerlokka-tracking.md?raw"
import usMatchAddresses from "./us-match-addresses.md?raw"

export const exampleBodies: Record<string, string> = {
  "brand-comparison/us-grocery-brand-comparison": usGroceryBrandComparison,
  "brand-comparison/us-how-far-visitors-travel": usHowFarVisitorsTravel,
  "store-profiling/us-heb-san-antonio-store-profile": usHebSanAntonioStoreProfile,
  "area-identification/us-cbg-scoring": usCbgScoring,
  "void-analysis/us-sprouts-white-space-denver": usSproutsWhiteSpace,
  "void-analysis/us-grocery-penetration-denver": usGroceryPenetration,
  "analog-modeling/us-candidate-malls-colorado": usCandidateMalls,
  "area-development-reporting/us-16th-street-denver": us16thStreet,
  "area-development-reporting/no-grunerlokka-tracking": noGrunerlokka,
  "match-locations/match-addresses-api": usMatchAddresses,
}

export function getExampleBody(
  guideSlug: string,
  exampleSlug: string,
): string | undefined {
  return exampleBodies[`${guideSlug}/${exampleSlug}`]
}
